// eslint-disable-next-line no-unused-vars
import VueRouter from "vue-router";

export function buildBreadcrumbs(currentRoute, routes) {
	let routes2 = [];
	while (currentRoute) {
		let obj = {path: currentRoute.path, name: currentRoute.name};
		if (currentRoute.meta) {
			if (currentRoute.meta.pageTitle) {
				obj.pageTitle = currentRoute.meta.pageTitle;
			}
			let nextRoute = null;
			if (currentRoute.meta.parent) {
				nextRoute = routes.find((route) => currentRoute.meta.parent === route.path);
			}
			else if (currentRoute.meta.parentName) {
				nextRoute = routes.find((route) => currentRoute.meta.parentName === route.name);
				nextRoute.useName = true;
			}
			currentRoute = nextRoute;
		}
		else {
			currentRoute = null;
		}
		routes2.push(obj);
	}
	let output = routes2.reverse();
	console.info("MFARouter buildBreadcrumbs", output);
	return output;
}

/**
 *
 * @param {*} routes
 * @param {*} EventBus
 * @param {VueRouter} router
 * @returns
 */
export const afterEachRouteChange = (routes, EventBus, router) => (to, from) => {
	let vueRouterItems = buildBreadcrumbs(to, routes);

	// The PBX ui-router is listening to this event.
	// The handler is just running the function with the enswitch navigation scope.
	EventBus.$emit("InnerNavigation", (scope) => {
		if (!scope.states) {
			// console.warn("Inner Navigation, invalid states array", scope);
			return null;
		}

		// Remove all the manual items because we will add them later again
		let items = scope.states.filter(item => item.source !== "vue-microapp");

		// If the customGoTo is not null inside the state object, when the user will click on the breadcrumb, we will run this function with preventDefault to disable the default href attribute of the link
		const customGoTo = (router, route) => () => {
			// debugger;
			if (route.name) {
				const gotoTarget = {name: route.name};
				console.info("MFARouter custom goto going to route by name", gotoTarget);
				router.push(gotoTarget);
			}
			else {
				console.info("MFARouter custom goto going to route by path", route.path);
				router.replace(route.path);
			}
		};

		// modify last enswitch route to use our first
		items[items.length - 1].customGoTo = customGoTo(router, vueRouterItems[0]);

		for (let i = 1; i < vueRouterItems.length; i++) {
			let item = vueRouterItems[i];
			items.push({
				source: "vue-microapp",
				data: {pageTitle: item.pageTitle},
				url: "",
				customGoTo: customGoTo(router, item)
			});
		}

		scope.states = items;
		console.info("MFARouter set breadcrumbs to", items);
		scope.$evalAsync();
	});
}
